import { AxiosError, AxiosResponse } from 'axios';

export type HttpResponse = AxiosResponse;
export type HttpError = AxiosError;

export type AuthenticationScheme = 'Basic' | 'Bearer';

export type ApiToken = {
  token: string;
  type: AuthenticationScheme;
};

export type BatchPayload = {
  id: number;
  method: 'get' | 'post' | 'delete' | 'put';
  url: string;
  body?: string;
};

export type BatchResponse = {
  headers: Record<string, string>;
  status: number;
  body: string;
};

export type fetchOptions = {
  headers?: Record<string, string>;
  requireCredentials?: boolean;
};

export type InstanceConfig = {
  name?: string;
  apiUrl: string;
  token: ApiToken;
  company: string;
};

export type GatewayOptions = {
  defaultHeaders?: Record<string, string>;
  interceptor?: {
    responseInterceptor: (response: AxiosResponse) => AxiosResponse;
  };
};

export interface IApiGateway {
  authorization: string;
  company: string;
  fetch(
    method: string,
    endpoint: string,
    payload?: unknown,
    options?: fetchOptions
  ): Promise<HttpResponse>;
  configure(baseUrl: string, token: ApiToken, company: string, options?: GatewayOptions): void;
  registerInstance(name: string, config: Partial<InstanceConfig>, options?: GatewayOptions): void;
  use(name: string): IApiGateway;
  createQueryParams(options?: Record<string, unknown>): string;
  batch(payload: BatchPayload[]): Promise<BatchResponse[]>;
  isRequestFailed(response: HttpResponse): boolean;
}

export const TYPES = {
  ApiGateway: Symbol('ApiGateway'),
};
